module.exports = __webpack_public_path__ + "static/media/under_monogram.a33983f7.png";